import { connect } from 'react-redux';
import { toggleModal } from 'store/ui/actions';

import { removePhoto } from '../../../redux/reducers/users/actions';
import RemovePhoto from './RemovePhoto';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    removePhoto: (look_uuid) => dispatch(removePhoto(look_uuid)),
    toggleModal: (data) => toggleModal(dispatch, data)
});

export default connect(mapStateToProps, mapDispatchToProps)(RemovePhoto);
